<!-- A DocumentList displays a list of documents -->
<template>
  <panel :height="5 * 80 + 67 + 64" :isLoading="isLoading">
    <template v-slot:header>
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- <v-btn v-if="hasAnyFilter" icon @click.stop="drawer = !drawer">
          <morph-icon :size="36" to-icon="mdi-close" from-icon="mdi-dots-vertical" :trigger="drawer"></morph-icon
        ></v-btn> -->
    </template>

    <template v-slot:content>
      <news-card :item="newsItem" :fixImgHeight="fixImgHeight"></news-card>
    </template>
  </panel>
</template>

<script>
/*
 * the config object needs the following feature flags:

 *
 * The config object may contain the following flags to enable the user to adjust his settings:
 * - userModuleSelectionEnabled
 * - userUnreadOnlySelectionEnabled
 * - userFolderSelectionEnabled
 * - userFavoriteSelectionEnabled
 * -
 */
import Panel from '@/components/container/Panel.vue';
import common from '@/mixins/common';
import { mapState } from 'vuex';
import configMixin from '../mixins/configMixin';
import NewsCard from '@/modules/news/NewsCard';
import dateUtils from '@/common/dateUtils';
export default {
  name: 'LatestNews',
  mixins: [common, configMixin],
  components: {
    Panel,
    NewsCard,
  },

  props: {
    config: { type: Object }, // widget configuration

    isLoading: { type: Boolean, default: false },
    noItemsMsg: String,
  },

  data() {
    return {
      widgetConfig: {},
      fixImgHeight: true,
    };
  },

  computed: {
    ...mapState('news', ['news']),
    title() {
      return this.config.title;
    },
    newsItem() {
      let news = this.news
        .slice(0)
        .sort((d1, d2) => {
          let date1 = dateUtils.parseISOString(d1.dateupdated).getTime();
          let date2 = dateUtils.parseISOString(d2.dateupdated).getTime();
          return date2 - date1;
        })
        .slice(0, 1);
      console.debug('news=', news);
      return news[0];
    },
  },
};
</script>
<style scoped>
.folder-selection-scroll-container {
  /* overflow-y: scroll !important; */
  /* height: 300px; */
  border: 1px solid white;
  border-radius: 10px;
}
.drawer {
  width: 100%;
  border: 1px solid white;
}
.scrollable-drawer {
  overflow-y: scroll;
  height: 100%;
}
</style>
